import { render, staticRenderFns } from "./JobStages.vue?vue&type=template&id=6c22b31a&"
import script from "./JobStages.vue?vue&type=script&lang=js&"
export * from "./JobStages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports